import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate, I18n } from 'react-redux-i18n';
import {
    TYPE_FILE,
} from 'components/Form/Input/input-type';
import { IMPORT_LIMIT_2MB } from 'constants/file';
import FlexGroup from 'components/FlexGroup';
import Form from 'components/Form';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import Blocker from 'components/Blocker';
import RingSpinner from 'components/Spinner/Ring';
import {
    toggleErrorDialog
} from 'actions';
import { useCreateInvoiceNotifierMutation } from 'redux/hook/useInoviceNotifier';
import { INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD } from 'constants/invoice-notifier';

const ImportFile = ({ onCancel }) => {
    const dispatch = useDispatch();
    const [invoiceFile, setInvoiceFile] = useState();
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const elFile = useRef();
    const elForm = useRef();
    const [createInvoiceNotifier] = useCreateInvoiceNotifierMutation();
    const spinnerStyle = classNames({
        'spinner-container': true,
        hide: !loading,
    });
    const handleSubmit = async () => {
        if (!invoiceFile) {
            return;
        }
        if (invoiceFile.size > IMPORT_LIMIT_2MB) {
            return dispatch(toggleErrorDialog(I18n.t('file_size_MB_warning', { size: 2 })));
        }
        setLoading(true);
        try {
            const { error } = await createInvoiceNotifier(invoiceFile);
            if (error) {
                const { code } = error?.data || {};

                let message = I18n.t('general_error_message');
                let invoiceNumber = '';
                if (code !== undefined && error.status !== 500) {
                    if (code === INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD) {
                        const errorMessage = error?.data?.message || '';
                        const match = errorMessage.match(/invoice number:\s*(.+)/i);
                        invoiceNumber = match ? match[1].trim() : '';

                        message = I18n.t(`invoice_winner_notifier.import_invoice_error_${code}`,
                            { invoice_number: invoiceNumber });
                    }
                    else {
                        message = I18n.t(`invoice_winner_notifier.import_invoice_error_${code}`);
                    }
                }
                dispatch(toggleErrorDialog(message));
            }
            else {
                setIsSuccess(true);
            }
        } finally {
            setLoading(false);
        }
    };

    const changeInvoiceFile = e => {
        const file = e.currentTarget.files[0];
        const reader = new FileReader();
        if (file) {
            reader.onload = () => {
                setFileName(file.name);
                setInvoiceFile(file);
                elFile.current.setCustomErrorMessage('');
            };
            reader.readAsText(file);
        }
    }

    const handleClose = () => {
        setIsSuccess(false);
        onCancel();
    }

    return (
        <>
            <Modal title={ I18n.t('import') } onClose={ onCancel }>
                <Form onSubmit={ handleSubmit } className="invoice-import" innerRef={ elForm }>
                    <Input
                        name="import_invoice"
                        type={ TYPE_FILE }
                        accept=".csv"
                        caption="invoice_winner_notifier.import_invoice_file"
                        required
                        onKeyDown={ e => e.preventDefault() }
                        onPaste={ e => e.preventDefault() }
                        onChange={ changeInvoiceFile }
                        value={ fileName }
                        innerRef={ elFile }
                    />
                    <FlexGroup end gap>
                        <Button type="button" className="btn-cancel" outline onClick={ onCancel }>
                            <Translate value="cancel" />
                        </Button>
                        <Button color="primary" type="submit">
                            <Translate value="submit" />
                        </Button>
                        <Blocker className={ spinnerStyle }>
                            <RingSpinner />
                        </Blocker>
                    </FlexGroup>
                </Form>
            </Modal>
            { isSuccess && (
                <Modal
                    title={ I18n.t('success') }
                    onClose={ handleClose }
                >
                    <FlexGroup start>
                        <Translate value="invoice_winner_notifier.import_success" />
                    </FlexGroup>
                    <FlexGroup end>
                        <Button
                            color="primary"
                            onClick={ handleClose }
                        >
                            <Translate value="ok" />
                        </Button>
                    </FlexGroup>
                </Modal> )
            }
        </>
    );
}

ImportFile.propTypes = {
    onCancel: PropTypes.func,
};

ImportFile.defaultProps = {
    onCancel: () => {},
};

export default ImportFile;
